import { Box } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const IntegrationIconBox = styled(Box)`
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0 20px;

  ${(props) =>
    props.googleSheet &&
    css`
      position: absolute;
      top: -3px;
      left: 1px;
      margin: 0 10px 0 0;
    `}

  ${(props) =>
    props.sendPulse &&
    css`
      margin: 0 4px 0 20px;
    `}
    ${(props) =>
    props.isBoxBannerMailingIntegrations &&
    css`
      width: 100%;
      height: 100%;
      margin: 0;
    `}
`;

export const IntegrationIconWrapper = styled(Box)`
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  background: #f2f6fc;
  border-radius: 15px;

  ${(props) =>
    props.active &&
    css`
      border: 3px #ffc561 solid;
    `}
`;

export const ActiveRectangle = styled.div`
  ${({ isActive }) =>
    isActive &&
    css`
      width: 39px;
      height: 66px;
      border: 1px solid #17ce17;
      border-radius: 5px;
      position: absolute;
      top: 10px;
    `}
`;

export const IntegrationIconIMG = styled.img`
  width: 30px;
  height: auto;
  cursor: pointer;

  ${(props) =>
    props.template &&
    css`
      box-shadow: rgba(0, 0, 0, 0.08) 1px 2px 10px;
      border-radius: 4px;
    `}

  ${(props) =>
    props.isActive &&
    css`
      border: 1px solid #17ce17;
      border-radius: 4px;
    `}


  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius};
    `}

  ${(props) =>
    props.isPng &&
    css`
      width: 39px;
      height: 61px;
      display: block;
      margin: 8px auto 11px;

      @media (max-width: 568px) {
        width: 27px;
        height: 42px;
        display: block;
        margin: 6px auto 9px;
      }
    `}

    ${(props) =>
    props.isMap &&
    css`
      height: 71px;
      width: 44px;
      margin-top: 8px;
      margin-bottom: 8px;
    `}

  ${(props) =>
    props.gif &&
    css`
      height: 70px;
      width: 44px;
      margin-top: 8px;
      margin-bottom: 8px;
    `}

  ${(props) =>
    props.isMargin &&
    css`
      margin-bottom: 8px;
    `}

  ${(props) =>
    props.insideEmail &&
    css`
      margin-top: 16px;
      margin-bottom: 16px;
    `}

  ${(props) =>
    props.isSubscribe &&
    css`
      height: 65px;
    `}

  ${(props) =>
    props.isContact &&
    css`
      height: auto;
      width: 43%;
      margin-top: 0px;
      margin-bottom: 8px;
    `}
    ${(props) =>
    props.isBannerMailingIntegrations &&
    css`
      width: 100%;
      height: 100%;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      object-fit: cover;
    `}
    ${(props) =>
    props.isTrashImg &&
    css`
      margin-left: auto;
      width: 20px;
      height: 20px;
      marginleft: 10px;
      cursor: pointer;
    `}
    ${(props) =>
    props.isEditImg &&
    css`
      margin-left: auto;
      width: 15px;
      height: 20px;
      marginleft: 10px;
      cursor: pointer;
    `}
    ${(props) =>
    props.isAccount &&
    css`
      width: 28px;
      height: 28px;
      border-radius: 50%;
    `}
`;

export const IntegrationIcon = styled.span`
  width: 30px;
  height: auto;
  cursor: pointer;

  ${(props) =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius};
    `}

  ${(props) =>
    props.isPng &&
    css`
      width: 39px;
      height: 61px;
      display: block;
      margin: 8px auto 11px;

      @media (max-width: 568px) {
        width: 27px;
        height: 42px;
        display: block;
        margin: 6px auto 9px;
      }
    `}


  ${(props) =>
    props.isTextAlign &&
    css`
      height: 25px;
      display: block;
    `}
`;

export const CustomDesignBox = styled(Box)`
  ${(props) =>
    props.$isNotActive &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: default;
    `}
`;

export const IconDesignMenu = styled(Box)`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    justify-content: space-between;
    gap: 10px;
    flex-wrap: nowrap;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const IconDesignMenuItem = styled(Box)`
  padding: 10px;
  min-height: 48px;
  min-width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: #f2f6fc;
  color: var(--main-black);
  border-radius: 15px;
  cursor: pointer;

  @media (max-width: 576px) {
    width: 100%;
    margin-right: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  [data-theme='dark'] & {
    background: var(--block-background);
  }

  ${(props) =>
    props.active &&
    css`
      border: 2px #ffc561 solid;
    `}

  ${(props) =>
    props.large &&
    css`
      gap: 8px;
      width: 120px;
    `}

  ${(props) =>
    props.socialIcon &&
    css`
      width: 60px;
      height: 60px;
    `}
  ${(props) =>
    props.subscribe &&
    css`
      width: 62px;
      height: 48px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.group &&
    css`
      width: 70px;
      max-width: 70px;

      svg {
        transform: rotate(90deg);
      }
    `}
`;

export const IconWrap = styled.img`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const TextWrap = styled.p`
  border-radius: 8px;
  background: rgb(242, 242, 242);
  color: rgba(0, 0, 0, 0.87);
  padding: 16px 24px;
  text-align: justify;
`;

export const IntegrationsNotifsList = styled(Box)`
  display: flex;
  justify-content: space-between;

  @media (max-width: 568px) {
    flex-direction: column;
  }
`;

export const IntegrationArrowTitle = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const IntegrationsList = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.arrangementOfBlocks &&
    css`
      display: grid;
      gap: 16px;
      justify-content: center;
      justify-items: center;
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));

      @media (max-width: 1300px) {
        grid-template-columns: repeat(2, minmax(230px, 1fr));
        justify-items: center;
      }

      @media (max-width: 1150px) {
        grid-template-columns: repeat(1, minmax(225px, 1fr));
        justify-items: left;
      }

      @media (max-width: 940px) {
        grid-template-columns: repeat(1, minmax(225px, 1fr));
        justify-items: center;
      }

      @media (max-width: 570px) {
        grid-template-columns: repeat(2, minmax(180px, 1fr));
        justify-items: center;
      }
    `}
`;

export const IntegrationsItem = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.google &&
    css`
      @media (max-width: 568px) {
        flex-direction: column;
      }
    `}

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
      margin-bottom: 35px;
    `}

  ${(props) =>
    props.isSectionSetting &&
    css`
      justify-content: flex-start;
    `}
    ${(props) =>
    props.boxMailingIntegration &&
    css`
      display: flex;
      flex-direction: column;

      padding: 0;
      border-radius: 8px;
      margin-bottom: 35px;
      width: 100%;
      max-width: 350px;
      height: 320px;
      border-radius: 30px;
      box-shadow: 0px 0px 19px 0px rgba(218, 218, 218, 1);

      [data-theme='dark'] & {
        background: var(--block-background);
        box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.5);
        border: 1px solid var(--border-color);
      }

      @media (max-width: 650px) {
        width: 100%;
        height: 310px;
      }
    `}
`;

export const IntegrationsItemMobile = styled(Box)`
  display: flex;
  margin: 0 0 16px 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  @media (max-width: 576px) {
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  ${(props) =>
    props.isHeaderView &&
    css`
      margin-left: -5px;

      @media (max-width: 768px) {
        flex-wrap: wrap;
      }

      @media (max-width: 576px) {
        flex-wrap: nowrap;
        justify-content: flex-start;
        scale: 0.8;
        width: 130%;
        margin-left: -62px;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isInsideLinks &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.isBanner &&
    css`
      margin-left: -30px;
    `}

  ${(props) =>
    props.isLayoutAlign &&
    css`
      @media (max-width: 576px) {
        justify-content: flex-start;
      }
      margin: 5px 0 12px;
    `}
`;

export const IntegrationsBox = styled(Box)`
 width: 50%;

  @media (max-width: 568px) {
    flex: none;
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.mobileWidth &&
    css`
      @media (max-width: 568px) {
        flex: none;
        width: ${props.mobileWidth};
      }
    `}

  ${(props) =>
    props.orderFields &&
    css`
      @media (max-width: 568px) {
        width: auto;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

   ${(props) =>
     props.googleSheet &&
     css`
       display: flex;
     `}


   ${(props) =>
     props.google &&
     css`
       @media (max-width: 568px) {
         margin-bottom: 10px;
       }
     `}

  ${(props) =>
    props.telegramPhoto &&
    css`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}

  ${(props) =>
    props.isInsideStorage &&
    css`
      margin-bottom: 25px;
    `}
    ${(props) =>
      props.boxBannerMailingIntegration &&
      css`
        width: 100%;
        height: 50%;
      `}
  ${(props) =>
    props.boxDescription &&
    css`
      width: 100%;
      padding: 0 16px 5px;
      margin-top: 10px;
    `}
     ${(props) =>
       props.boxDescriptionFlex &&
       css`
         display: flex;
         align-items: center;
       `}

    ${(props) =>
      props.boxDescPro &&
      css`
        display: flex;
        width: 100%;
        align-items: center;
      `}
      ${(props) =>
        props.boxPro &&
        css`
          width: 52px;
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          background: #000000;
          border-radius: 30px;
          padding: 3px 0;
          margin-left: auto;

          @media (max-width: 576px) {
            width: 52px;
          }
        `}
        ${(props) =>
          props.boxDisconnect &&
          css`
            width: 100%;
            display: flex;
            justify-content: center;
            padding-bottom: 5px;
            align-items: center;
            margin-bottom: 10px;
            margin-top: 0;
          `}
      ${(props) =>
        props.boxButton &&
        css`
          width: 100%;
          margin-top: auto;
        `};

        ${(props) =>
          props.boxConnectedPin &&
          css`
            width: auto;
            background: #ebfcf6;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            border-radius: 30px;
            padding: 5px 10px;
            margin-left: 5px;
          `};
}`;

export const IntegrationsBoxMobileView = styled(Box)`
  position: relative;
  width: 23%;
  text-align: center;

  @media (max-width: 576px) {
    width: 100%;
  }

  ${(props) =>
    props.isNotPro &&
    css`
      &:after {
        content: 'PRO';
        position: absolute;
        top: 14px;
        right: 3px;
        width: 36px;
        height: 16px;
        background: #39e09b;
        font-size: 9px;
        color: #fff;
        text-align: center;
        line-height: 16px;
        border-radius: 3px;
        margin-top: -10px;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.headerLayout &&
    css`
      //height: 130px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      //svg {
      //  position: absolute;
      //  top: -35px;
      //  left: -25px;
      //}

      @media (max-width: 768px) {
        width: 48%;
      }

      @media (max-width: 576px) {
        width: 25%;
      }
    `}

  ${(props) =>
    props.isInsideHeader &&
    css`
      margin-left: -20px;

      @media (max-width: 768px) {
        margin-left: -5px;
      }
    `}

  ${(props) =>
    props.isInsideLinks &&
    css`
      margin-left: -12px;

      @media (max-width: 768px) {
        margin-left: -12px;
      }
    `}

  ${(props) =>
    props.widthMobile &&
    css`
      @media (max-width: 768px) {
        width: ${props.widthMobile};
      }
    `}

  ${(props) =>
    props.slider &&
    css`
      width: auto;

      @media (max-width: 768px) {
        width: auto;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.alignText &&
    css`
      width: 55px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;

      margin-left: 0;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }

      @media (max-width: 768px) {
        margin-left: 0;
      }

      background: #f2f6fc;
      border-radius: 15px;

      ${(props) =>
        props.active &&
        css`
          border: 3px #ffc561 solid;
        `}
    `}


  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isEmailHeader &&
    css`
      margin-right: 10px;
    `}
`;

export const IntegrationsInputTitle = styled(Box)`
  ${(props) =>
    props.gallery &&
    css`
      margin-top: -10px;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const IntegrationTelegramBox = styled(Box)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.isSectionSetting &&
    css`
      padding: 4px;
      padding-left: 12px;
      background: var(--secondary-background);
      border: 1px solid var(--border-color);
      border-radius: 8px;
    `}
`;

export const IntegrationText = styled(Box)`
  margin-left: 8px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.textForAccount &&
    css`
      width: 100%;
      color: var(--main-black);
    `}
  ${(props) =>
    props.textEmail &&
    css`
      width: 100%;
      color: var(--main-black);
      line-height: revert;
      height: 30px;
    `}
`;

export const IntegrationArrowIconBox = styled(Box)`
  margin-left: auto;
  cursor: pointer;
  padding: 10px;

  ${(props) =>
    props.generateApiKey &&
    css`
      position: absolute;
      right: 0;
      bottom: 44px;
      color: #4e75fe;
      font-size: 14px;
    `}

  ${(props) =>
    props.notification &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: var(--main-gray);
      margin-left: 8px;
    `}
`;

export const IntegrationsButtons = styled(Box)`
  display: flex;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const IntegrationsButtonsWrap = styled(Box)`
  margin-right: 15px;

  @media (max-width: 768px) {
    margin: 0;
    width: 48%;
  }
`;
